<div *ngIf="loading" class="loading">
    <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
</div>
<div class="attendance-reports-container" id="report-card" >
    <div class="attendance-reports-container-header">
    </div>
    <!-- (exportExcel)="exportToExcelFile()" -->
    <app-reports-control-bar [listType]="listType" [controlType]="controlType"  (generateExcel)="generateExcelFile()"></app-reports-control-bar>
    <div [class.rtl]="currLang == 'ar'">
        <app-filter  [class]="filterStatus ? 'side-bar show' : 'side-bar'" [ngClass]="(currLang == 'en') ? 'left' : 'right'" [listType]="listType"></app-filter>
    </div>
    <div class="attendace-reports-body-container">
        <!-- <div [class]="reportType === 'week' ? 'attendace-reports-body':'attendace-reports-body days'">
            <app-table-view [controls]="tableControls" (eventHandeler)="tableEventHandeler($event)"></app-table-view>
        </div> -->

        <div class="attendace-reports-body">
            <app-table-view [controls]="tableControls" (eventHandeler)="tableEventHandeler($event)"></app-table-view>
        </div>
        <!-- <div *ngIf="reportType ==='day'" class="grade-class-details">
            <div class="grade-class-details-header">
                <label>{{reportFilter?.grade.name}}, {{reportFilter?.clazz.name}}</label>
            </div>
            <div class="grade-class-details-body" [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
                <span>{{'student-attendance.class-student' | translate}} : {{classStudents}}</span>
                <span>{{'student-attendance.teacher' | translate}} : {{teacherName}}</span>
                <span>{{'student-attendance.percentage' | translate}} : {{attendancePercentage.toFixed(2)}}%</span>
            </div>
        </div> -->
    </div>
</div>
<app-student-attendance-report></app-student-attendance-report>